<button class="btn-select" (click)="handleClickTogglenOptions()">
  {{ 'LANGUAGES.' + currentLang.toUpperCase() | translate }}
</button>
@if (showLanguages) {
  <ul>
    <li *ngIf="language() !== 'pt-br'">
      <button (click)="changeLanguage('pt-br')">
        {{ 'LANGUAGES.PT-BR' | translate }}
      </button>
    </li>
    <li *ngIf="language() !== 'en-us'">
      <button (click)="changeLanguage('en-us')">
        {{ 'LANGUAGES.EN-US' | translate }}
      </button>
    </li>
  </ul>
}
